import {WIDGET_TYPES, WIDGETS_PARAMS_RESOURCE} from "../../consts";
import {PublisherApiModel} from "../../../domain/publisher/models/publisher.api-model";
import {SiteConfig} from "../../bootstrap/models/site-config";
import {BaseModuleSettings} from "../../../infrastructure/models/base-module-settings";
import {BootstrapSettings} from "../../bootstrap/models/bootstrap-settings";
import {PublisherViewModel} from "../../../domain/publisher/models/publisher.view-model";
import {singleton} from "../../../infrastructure/decorators/singleton";

@singleton
export class AppSettings extends BaseModuleSettings {
  config: SiteConfig;

  constructor(settings: BootstrapSettings, siteConfig: SiteConfig) {
    super(settings);

    this.config = siteConfig;
  }

  get adsProvider(): Boolean {
    return this.bootstrapSettings.adsProvider;
  }

  get widgetType(): WIDGET_TYPES {
    return this.bootstrapSettings.widgetType;
  }

  get partnerModel(): PublisherApiModel {
    return this.config.partnerModel;
  }

  get isWidget(): Boolean {
    return this.widgetType !== WIDGET_TYPES.website;
  }

  get allowPremiumData(): Boolean {
    return this.bootstrapSettings.allowPremiumData || !this.isWidget;
  }

  get cultureName(): String {
    return (this.bootstrapSettings.lang || '').toLowerCase();
  }

  get userCountryId(): String {
    return this.bootstrapSettings.userCountryId;
  }

  get isContextualMode(): Boolean {
    return this.isWidget && this.bootstrapSettings.paramsResource === WIDGETS_PARAMS_RESOURCE.contextual;
  }

  get isUrlMode(): Boolean {
    return this.isWidget && this.bootstrapSettings.paramsResource === WIDGETS_PARAMS_RESOURCE.url;
  }

  get publisherSettings(): PublisherViewModel {
    return new PublisherViewModel(this.bootstrapSettings.publisherId, this.bootstrapSettings.sponsoredBookmakerUrl, this.bootstrapSettings.allScoresUrl)
  }

  get useScrollingButtons(): Boolean {
    return this.isWidget && this.bootstrapSettings.useScrollingButtons;
  }

  get hideCompetitionTitle(): Boolean {
    return this.isWidget && this.bootstrapSettings.hideCompetitionTitle;
  }

  get hideHomeAwayTabs(): Boolean {
    return this.isWidget && this.bootstrapSettings.hideHomeAwayTabs;
  }
}
